import Checkbox from 'components/Checkbox'
import { MAX_WIDTH_MEDIA_BREAKPOINT } from 'components/Tokens/constants'
import React, { useEffect, useState } from 'react'
import { useShowInfoAfter } from 'state/competition/hooks'
import { updateShowInfo } from 'state/competition/reducer'
import { useAppDispatch } from 'state/hooks'
import styled from 'styled-components/macro'
import { CloseIcon } from 'theme'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  margin-left: auto;
  margin-right: auto;
  border-radius: 12px;
  justify-content: center;
  align-items: flex-start;
  background: ${({ theme }) => theme.backgroundSwap};
  border: 1px solid ${({ theme }) => theme.backgroundSwapOutline};
  box-shadow: ${({ theme }) => theme.backgroundSwapShadow};
  padding: 12px;
  margin-bottom: 2rem;
  gap: 0.5rem;
`

const Close = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
`

const Label = styled.div`
  font-size: 17px;
  font-weight: 600;
  padding-right: 20px;
`

const Desc = styled.div`
  font-size: 14px;
  /* font-weight: 600; */
`

const CloseIconBg = styled(CloseIcon)`
  background: ${({ theme }) => theme.backgroundOutline};
  border-radius: 50%;
  padding: 3px;
`

const Disclaimer = () => {
  const showInfoAfter = useShowInfoAfter()
  const dispatch = useAppDispatch()
  const [checked, setChecked] = useState(false)
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    if (Date.now() > showInfoAfter) {
      setOpen(true)
    }
  }, [showInfoAfter])

  const handleClose = () => {
    if (checked) {
      const month = new Date()
      month.setDate(month.getDate() + 30)
      dispatch(updateShowInfo({ timestamp: month.getTime() }))
    } else {
      const now = new Date()
      now.setHours(now.getHours() + 5)
      dispatch(updateShowInfo({ timestamp: now.getTime() }))
    }
    setOpen(false)
  }

  return isOpen ? (
    <Wrapper>
      <Close>
        <CloseIconBg onClick={handleClose} data-testid="confirmation-close-icon" />
      </Close>

      <Label>Join the excitement at XSwap's Trading Competition!</Label>
      <Desc>
        <p>
          Calling all traders! Get ready to showcase your skills and compete against fellow enthusiasts in our thrilling
          trading competition. With exciting prizes up for grabs, it's your chance to demonstrate your trading prowess
          and climb the leaderboard.
        </p>
        <p>
          Plus, don't forget about our referral bonuses! Invite your friends to join the competition and earn referral
          bonuses to boost your score even higher.
        </p>
        <p>Don't miss out on the action! Join now and unleash your trading potential with XSwap. See you at the top!</p>
      </Desc>
      <Checkbox id="info" label="Never show again" value="" checked={checked} onChange={() => setChecked(!checked)} />
    </Wrapper>
  ) : null
}

export default Disclaimer
